<template>
  <div class="rules">
    <img src="../assets/rules.jpg" alt="" />
    <div class="agree">
      <el-checkbox @change="handleChange">本人已阅读并接受考试安排</el-checkbox>
      <div class="sucBox">
        <el-button class="suc" type="primary" round @click="toExam"
          >确　　认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Rules",
  data() {
    return {
      suc: true,
    };
  },
  methods: {
    handleChange(val) {
      if (val) {
        this.suc = false;
      } else {
        this.suc = true;
      }
    },
    toExam() {
      if (this.suc) {
        this.$message.warning("阅读考试守则并接受考试安排才能答题！");
      } else {
        let id = this.$route.params.id;
        this.$router.push({ name: "entrance", params: { id: id } });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.rules {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
  }
}
.rules img {
  width: 100%;
}
.agree {
  position: absolute;
  bottom: 50px;
  width: 100%;
  padding: 0 28px;
  box-sizing: border-box;
}
.sucBox {
  text-align: center;
  padding-top: 20px;
}
.suc {
  width: 70% !important;
}
</style>
